<template lang="pug">

  //v-card(class="overflow-hidden")
    v-app-bar(absolute color="#6A76AB" dark shrink-on-scroll prominent src="https://picsum.photos/1920/1080?random" fade-img-on-scroll scroll-target="#scrolling-techniques-3")
      template(v-slot:img="{ props }")
        v-img(v-bind="props" gradient="to top right, rgba(100,115,201,.7), rgba(25,32,72,.7)")

      v-app-bar-nav-icon
      v-toolbar-title Title

      v-spacer

      v-btn(icon)
        v-icon mdi-magnify

      v-btn(icon)
        v-icon mdi-heart

      v-btn(icon)
        v-icon mdi-dots-vertical

      template(v-slot:extension)
        v-tabs(align-with-title)
          v-tab Tab 1
          v-tab Tab 2
          v-tab Tab 3

    v-sheet(id="scrolling-techniques-3" class="overflow-y-auto" max-height="600")
    v-container(style="height: 1000px;")


  div(id="app")

    validation-provider(rules="required" v-slot="{ errors }")
      input(v-model="value" name="myinput" type="text")
      span {{ errors[0] }}

</template>

<script>

import { ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'The {_field_} field is required'
});

export default {
  name: 'app',
  components: {
    ValidationProvider
  },
  data: () => ({
    value: ''
  })
}
</script>

<style>

</style>
